import Dexie from 'dexie';
import { appConfig } from '../../../environments/environment';
import * as debug from '../services/debug.service';

export abstract class LocalDb extends Dexie {
	profiles: Dexie.Table<IProfile, number>;
	errors: Dexie.Table<IClientError, number>;

	constructor() {
		super(appConfig.localDbName);
		this.version(1).stores({
			errors: '++id',
			profiles: '++id, isGuest'
		});
	}

	async clearAll(): Promise<void> {
		const that = this;

		that.tables.forEach(async table => {
			await table.clear();
		});

		debug.log('093 LocalDb clearAll success!');

		return Promise.resolve();
	}
}

export interface IClientError {
	id?: number;
	error: string;
}

export interface IProfile {
	id: number;
	isGuest: string;
	data: string;
}
